import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from 'routes/paths';

export const Footer = () => {
  return (
    <footer className="px-4 sm:px-8 py-12 md:py-16 border-t border-[var(--border-100)] bg-[var(--bg-white)] rounded-b-[1.5rem] md:rounded-b-[2.5rem] relative z-20 overflow-hidden">
      
      {/* --- PRE-FOOTER CTA SECTION --- */}
      <section className="pb-20 md:pb-24 pt-4 md:pt-12 px-2 sm:px-6 lg:px-0 max-w-7xl mx-auto">
        <div 
          className="w-full bg-[#2e3543] rounded-[2rem] md:rounded-[3rem] overflow-hidden relative group"
          style={{ boxShadow: '0 30px 60px -12px rgba(46, 53, 67, 0.3)' }}
        >
          {/* Subtle slate Glow in the Corner (Scaled for mobile) */}
          <div className="absolute top-0 right-0 w-[250px] h-[250px] md:w-[400px] md:h-[400px] bg-[#cbd5e1] blur-[80px] md:blur-[100px] rounded-full -translate-y-1/2 translate-x-1/4 pointer-events-none opacity-30 md:opacity-100"></div>

          <div className="flex flex-col md:flex-row items-center justify-between p-8 sm:p-12 md:p-20 relative z-10 gap-8 md:gap-10">
            
            {/* Left Side: The Hook */}
            <div className="max-w-2xl text-center md:text-left flex flex-col items-center md:items-start">
              <div className="flex flex-col md:flex-row items-center justify-center md:justify-start gap-4 mb-4 md:mb-6">
                 {/* Decorative Line (Hidden on mobile for cleaner stacking) */}
                 <div className="hidden md:block w-1.5 h-10 bg-white rounded-full"></div>
                 <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tighter leading-tight">
                   Build Up Your Skills Today <br className="hidden sm:block" />
                   <span className="text-slate-300 sm:block">And Get The Career You Want</span>
                 </h2>
              </div>
              
              <p className="text-slate-400 text-base md:text-lg font-medium leading-relaxed max-w-xl">
                Join the elite circle of creators mastering the digital economy. Your growth starts the moment you stop waiting.
              </p>
            </div>

            {/* Right Side: The Action */}
            <div className="flex-shrink-0 w-full md:w-auto mt-2 md:mt-0">
              <button 
                className="w-full md:w-auto bg-white text-[#2e3543] px-8 sm:px-12 py-4 sm:py-5 rounded-xl sm:rounded-2xl font-black text-sm sm:text-base uppercase tracking-widest hover:bg-gray-100 transition-all hover:-translate-y-1 shadow-xl relative z-10 active:scale-95"
              >
                JOIN NOW
              </button>
            </div>

          </div>

          {/* The Signature Bottom Accent Line */}
          <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-slate-400/30 to-transparent"></div>
        </div>
      </section>

      
      {/* --- 3-COLUMN FOOTER LINKS --- */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:flex md:flex-wrap md:justify-between gap-10 md:gap-12 mb-12 md:mb-16 px-4">
        
        {/* Column 1: Brand & Description */}
        <div className="sm:col-span-2 md:col-span-1">
            <Link to={PATHS.home}>
                      <div className="flex items-center gap-2 pl-2 cursor-pointer group mb-4">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-[var(--primary)] group-hover:scale-110 transition-transform duration-500">
                          <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="currentColor"/>
                          <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span className="text-base font-extrabold text-[#2e3543] tracking-tight">LearnSocialAI</span>
                      </div>
                    </Link>
          <p className="text-[var(--text-500)] max-w-sm leading-relaxed mb-8 font-medium text-sm md:text-base">
            The ultimate academy for mastering social media growth, content strategy, and digital monetization. Education that moves with you — anytime, anywhere.
          </p>
              <div className="flex items-center gap-4">
            <img src="/MastercardPay.svg" alt="master-card" width="42" height="27" />
            <img src="/sepaPay.svg" alt="sepa" width="88" height="24" />
            <img src="/visaPay.svg" alt="visa" width="37" height="23" />
          </div>
        </div>
        
        {/* Column 2: Platform Links */}
        <div>
          <h3 className="font-bold text-[var(--text-900)] mb-4 md:mb-6 text-base md:text-lg">Quick links</h3>
          <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-[var(--text-500)] font-medium">
            <li><Link to={PATHS.home} className="hover:text-[var(--text-900)] transition-colors">Home</Link></li>
            <li><Link to={PATHS.library} className="hover:text-[var(--text-900)] transition-colors">Library</Link></li>
            <li><Link to={PATHS.pricing} className="hover:text-[var(--text-900)] transition-colors">Pricing</Link></li>
            <li><Link to={PATHS.unsubscribe} className="hover:text-[var(--text-900)] transition-colors">Unsubscribe</Link></li>
          </ul>
        </div>

   <div>
          <h3 className="font-bold text-[var(--text-900)] mb-4 md:mb-6 text-base md:text-lg">Legal</h3>
          <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-[var(--text-500)] font-medium">
            <li><Link to={PATHS.privacy} className="hover:text-[var(--text-900)] transition-colors whitespace-nowrap">Privacy Policy</Link></li>
            <li><Link to={PATHS.terms} className="hover:text-[var(--text-900)] transition-colors whitespace-nowrap">Terms & Conditions</Link></li>
            <li><Link to={PATHS.imprint} className="hover:text-[var(--text-900)] transition-colors whitespace-nowrap">Imprint</Link></li>
          </ul>
        </div>

        {/* Column 4: Company Details */}
        <div>
          <h3 className="font-bold text-[var(--text-900)] mb-4 md:mb-6 text-base md:text-lg">Company Details</h3>
          <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-[var(--text-500)] font-medium">
            <li>Company Name: OEDUC LTD</li>
            <li>Company Address: Kalergi, 18 Egkomi,<br />2400, Nicosia, Cyprus</li>
            <li>
              Email:{' '}
              <a href="mailto:support@LearnSocialAI.net" className="hover:text-[var(--text-900)] transition-colors">
                support@LearnSocialAI.net
              </a>
            </li>
          </ul>
        </div>
     

      </div>

      {/* --- COPYRIGHT BAR --- */}
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-center items-center gap-4 text-xs sm:text-sm text-[var(--text-400)] font-medium pt-8 border-t border-[var(--border-100)] px-4 text-center md:text-left">
        <p>Copyright © 2026 LearnSocialAI. All Rights Reserved.</p>
       
      </div>

    </footer>
  );
};
